/**
 * AiLoading — AI 消息 loading 状态的轮播提示组件
 * 抽到独立文件以满足 React Fast Refresh 约束（同文件只能导出组件）
 */
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";

const LOADING_MESSAGES = [
  "Analyzing your question…",
  "Searching the sources…",
  "Getting the gist…",
  "Scanning the text…",
];

const AiLoading: React.FC = () => {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Spin indicator={<LoadingOutlined spin style={{ fontSize: 16 }} />} size="small" />
      <Typography.Text style={{ color: "rgba(0,0,0,0.45)", fontSize: 14 }}>
        {LOADING_MESSAGES[index]}
      </Typography.Text>
    </div>
  );
};

export default AiLoading;
